import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-real-sports-tab',
  templateUrl: './real-sports-tab.component.html',
  styleUrls: ['./real-sports-tab.component.scss'],
  imports: [],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RealSportsTabComponent {}
